import { Movimentacao } from './../../../_core/models/movimentacao';
import { Component, Input, OnInit } from '@angular/core';
import { MovimentacaoService } from 'src/app/_core/services/movimentacao.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadService } from 'src/app/_core/services/upload.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-historico-bens-modal',
  templateUrl: './historico-bens-modal.component.html',
  styleUrls: ['./historico-bens-modal.component.scss']
})
export class HistoricoBensModalComponent implements OnInit {
  @Input() public nR_BPM_BEM_PATRIMONIAL: number;
  @Input() public cD_BPM_MOVIMENTACAO_PATRIMONIAL: number;
  @Input() public cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM: number;
  movimentacao:Movimentacao[];
  loading = true;
  isCollapsedFile = true;
  constructor(
    private movimentacaoService:MovimentacaoService,
    public activeModal: NgbActiveModal,
    private uploadService:UploadService)
  {}

  ngOnInit(): void {
    this.loading = false;
    // this.getHistById();
    this.getHistDetalhar();
  }
  // getHistById(){
  //   this.movimentacaoService.mov_getBy2Id(
  //     this.nR_BPM_BEM_PATRIMONIAL,this.cD_BPM_MOVIMENTACAO_PATRIMONIAL)
  //   .subscribe(
  //     data=>{
  //       this.movimentacao = data;
  //       //console.log/this.movimentacao)
  //     }
  //   )
  // }
  getHistDetalhar(){
    this.movimentacaoService.mov_getHistDetalhar(
      this.nR_BPM_BEM_PATRIMONIAL,this.cD_BPM_MOVIMENTACAO_PATRIMONIAL,
      this.cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM).subscribe(
        data =>{
          this.movimentacao = data;
  //       //console.log/this.movimentacao)
        }
      )
  }
  upload_abrir(dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL: any,cD_BPM_ARQUIVO_PATRIMONIAL: number) {
    this.uploadService.upload_abrir(cD_BPM_ARQUIVO_PATRIMONIAL)
      .subscribe(
        data => {
          var uri = encodeURIComponent(data)
         window.open(env.baseurl + '/Arquivo/'+this.nR_BPM_BEM_PATRIMONIAL+'/'+cD_BPM_ARQUIVO_PATRIMONIAL)
    })
}
}
